import { timeFormat } from "./base";
import { isArray } from "vue-resource/src/util";
import { t } from "../i18n/index";

export const sprintf = require('locutus/php/strings/sprintf')

const FRAME_KEY_NAME = {
    'report_time': t(/*上报时间*/'event.report_time'),
    'report_type': t(/*上报类型*/'event.report_type'),

    'protocol_version': t(/*'协议版本*/'device.protocol_version'),
    'software_version': t(/*'软件版本*/'device.software_version'),
    'hardware_version': t(/*'硬件版本*/'device.hardware_version'),
    'iccid': 'ICCID',
    'imsi': 'IMSI',
    'fota_version': t(/*'固件版本*/'device.fota_version'),

    'longitude': t(/*'经度*/'c.longitude'),
    'latitude': t(/*'纬度*/'c.latitude'),
    'navigate': t(/*'朝向*/'device.navigate'),
    'satellite_count': t(/*'卫星个数*/'device.satellite_count'),
    'speed': t(/*'速度*/'device.speed'),

    'mileage': t(/*'本次骑行里程*/'device.mileage_curr'),
    'mileage_total': t(/*'总骑行里程*/'device.mileage_total'),
    'battery': t(/*'电量*/'device.battery_power'),
    'mileage_endurance': t(/*'续航能力*/'device.mileage_endurance'),
    'lock_status': t(/*'设防状态*/'device.lock_status'),
    'boot_status': t(/*'⻋辆启动状态*/'device.boot_status'),
    'gsm_signal_strength': 'GSM' + t(/*'信号强度*/'device.signal_strength'),
    'gps_signal_strength': 'GPS' + t(/*信号强度*/'device.signal_strength'),
    'gps_satellite_count': 'GPS' + t(/*卫星数量*/'device.satellite_count'),
    'ecu_battery': t(/*'ECU电池电量*/'device.ecu_battery'),
    'ecu_gps_status': t(/*'ECU-GPS模组状态*/'device.ecu_gps_status'),

    'bms_count': t(/*'BMS个数*/'device.bms_count'),
    'bms_1_sn': t(/*'BMS1序列号*/'device.bms_1_sn'),
    'bms_1_charge_count': 'BMS1' + t(/*'BMS1充电次数*/'device.charge_count'),
    'bms_1_discharge_count': 'BMS1' + t(/*'BMS1放电次数*/'device.discharge_count'),
    'bms_1_max_temperature': 'BMS1' + t(/*'BMS1最高温度*/'device.max_temperature'),
    'bms_2_sn': t(/*'BMS2序列号*/'device.bms_2_sn'),
    'bms_2_charge_count': 'BMS2' + t(/*'充电次数*/'device.charge_count'),
    'bms_2_discharge_count': 'BMS2' + t(/*'放电次数*/'device.discharge_count'),
    'bms_2_max_temperature': 'BMS2' + t(/*'最高温度*/'device.max_temperature'),
};

export function portStatusFormat(v) {
    if (!Number.isInteger(v)) {
        return '-'
    }

    v = parseInt(v);

    let parts = [];

    switch ((v >> 7) & 0x1) {
        case 0: parts.push(t(/*离线*/'device.status.offline')); break;
        case 1: parts.push(t(/*在线*/'device.status.online')); break;
    }

    let chargeStatus = (v >> 4) & 0x3;
    let chargeStatusName = '';
    switch (chargeStatus) {
        case 0: chargeStatusName = t(/*未充电*/'frame.charge_status.not_charging'); break;
        case 1: chargeStatusName = t(/*充电*/'frame.charge_status.charging'); break;
        case 2: chargeStatusName = t(/*充满*/'frame.charge_status.fully_charged'); break;
        case 3: chargeStatusName = t(/*时间满*/'frame.charge_status.time_is_up'); break;
    }
    if (chargeStatusName !== '') {
        parts.push(chargeStatusName)
    }

    if (v & 0x1 !== 0) {
        parts.push(t(/*过载*/'frame.overload'));
    }
    if ((v >> 1) & 0x1 !== 0) {
        parts.push(t(/*过流*/'frame.overcurrent'));
    }
    if ((v >> 2) & 0x1 !== 0) {
        parts.push(t(/*过温*/'frame.overtemperature'));
    }
    if ((v >> 3) & 0x1 !== 0) {
        parts.push(t(/*空载*/'frame.no_load'));
    }
    if ((v >> 6) & 0x1 !== 0) {
        parts.push(t(/*计量电路故障*/'frame.metering_circuit_fault'));
    }

    return parts.join(', ')
}
export function gunStatusFormat(v) {
    if (!Number.isInteger(v)) {
        return '-'
    }

    v = parseInt(v);

    let parts = [];

    switch ((v >> 5) & 0x1) {
        case 0: parts.push(t(/*离线*/'device.status.offline')); break;
        case 1: parts.push(t(/*在线*/'device.status.online')); break;
    }

    let chargeStatus = (v >> 9) & 0x3;
    let chargeStatusName = '';
    switch (chargeStatus) {
        case 0: chargeStatusName = t(/*未充电*/'frame.charge_status.not_charging'); break;
        case 1: chargeStatusName = t(/*充电*/'frame.charge_status.charging'); break;
        case 2: chargeStatusName = t(/*充满*/'frame.charge_status.fully_charged'); break;
        case 3: chargeStatusName = t(/*时间满*/'frame.charge_status.time_is_up'); break;
    }
    if (chargeStatusName !== '') {
        parts.push(chargeStatusName)
    }

    if (v & 0x1 !== 0) {
        parts.push(t(/*过载*/'frame.overload'));
    }
    if ((v >> 1) & 0x1 !== 0) {
        parts.push(t(/*过流*/'frame.overcurrent'));
    }
    if ((v >> 2) & 0x1 !== 0) {
        parts.push(t(/*过温*/'frame.overtemperature'));
    }
    if ((v >> 3) & 0x1 !== 0) {
        parts.push(t(/*空载*/'frame.no_load'));
    }
    if ((v >> 4) & 0x1 !== 0) {
        parts.push(t(/*电表故障*/'frame.electric_meter_failure'));
    }
    if ((v >> 6) & 0x1 !== 0) {
        parts.push(t(/*漏电*/'frame.electric_leakage'));
    }
    if ((v >> 7) & 0x1 !== 0) {
        parts.push(t(/*CP状态异常*/'frame.cp_status_is_abnormal'));
    }
    if ((v >> 8) & 0x1 !== 0) {
        parts.push(t(/*充电枪插入*/'frame.charging_gun_insertion'));
    }

    return parts.join(', ')
}

export function parse26001Frame(data, space) {
    console.log(data);
    if (!data || !data['frame']) {
        return '-'
    }
    let frame = data['frame'];
    let type = parseInt(frame['type']);
    let command = frame['command'] || '';
    let allItems = {};
    for (let k in frame) {
        let v = frame[k];
        if (isArray(v)) {
            allItems[k] = v;
        } else if (typeof v === 'object') {
            let prefix = '';
            switch (k) {
                // 21003
                case 'node': {
                    prefix = 'node.';
                } break;

                // 21003
                case 'card': {
                    prefix = 'card.';
                    break
                }

                // 21004
                case 'port_0': {
                    prefix = 'node.p_1_';
                } break;

                // 21004
                case 'port_1': {
                    prefix = 'node.p_2_';
                } break;
            }
            for (let sk in v) {
                allItems[prefix + sk] = v[sk];
            }
        } else {
            allItems[k] = v;
        }
    }
    let keyList = [];
    let typeName = t(/*未知*/'c.unknown');
    switch (space) {
        case '26001':
        case '26003': {
            let portKeyList = ['device_id', 'temperature', 'port_list'];
            switch (type) {
                case 0x1: {
                    typeName = t(/*登录*/'frame.login');
                    keyList = ['report_time', 'protocol_version', 'software_version', 'hardware_version', 'fota_version', 'iccid', 'imsi'];
                    break;
                }

                case 0x2: {
                    typeName = 'GPS';
                    keyList = ['report_time', 'report_type', 'longitude', 'latitude', 'navigate', 'satellite_count', 'speed'];
                    break;
                }

                case 0x3: {
                    typeName = t(/*车辆状态*/'frame.vehicle_status');
                    keyList = ['report_time', 'report_type', 'mileage', 'mileage_total', 'battery', 'mileage_endurance', 'lock_status', 'boot_status',
                        'gsm_signal_strength', 'gps_signal_strength', 'gps_satellite_count', 'ecu_battery', 'ecu_gps_status',
                    ];
                    break;
                }

                case 0x0A: {
                    typeName = 'BMS';
                    keyList = ['report_time', 'bms_count', 'bms_1_sn', 'bms_1_charge_count', 'bms_1_discharge_count', 'bms_1_max_temperature',
                        'bms_2_sn', 'bms_2_charge_count', 'bms_2_discharge_count', 'bms_2_max_temperature',
                    ];
                    break;
                }
            }
        } break;
    }

    let parsePortList = function (portList, nodeIndex) {
        if (!Array.isArray(portList)) {
            return
        }

        let itemList = [];

        for (let portKey in portList) {
            let port = portList[portKey];
            console.log(portKey, port)
            if (!port.hasOwnProperty('port_index') && !port.hasOwnProperty('index')) {
                continue;
            }
            let portIndex = port['port_index'];
            if (portIndex === undefined) {
                portIndex = port['index'];
            }
            if (portIndex === undefined) {
                portIndex = '-';
            }
            let keyNamePrefix = `${t(/*节点*/'frame.node')}${nodeIndex}${t(/*孔*/'frame.port')}${portIndex} : `
            let portItemList = [];

            let portKeys = ['port_index', 'index', 'transaction_id', 'current', 'voltage', 'power', 'time_consumed', 'energy_consumed', 'status']
            for (let portPropKeyIndex in portKeys) {
                let portPropKey = portKeys[portPropKeyIndex];
                if (portPropKey === 'port_index') {
                    continue
                }
                let portPropName = FRAME_KEY_NAME[`port.${portPropKey}`] || '';
                let portPropValue = port[portPropKey];
                if (portPropValue === undefined) {
                    portPropValue = '-';
                }

                switch (portPropKey) {
                    case 'port_index': continue
                    case 'index': continue
                    case 'status': {
                        portPropValue = `${portPropValue}(${portStatusFormat(portPropValue)})`;
                    } break;
                    case 'gun_status': {
                        portPropValue = `${portPropValue}(${gunStatusFormat(portPropValue)})`;
                    } break;

                }

                portItemList.push(`<span class="item ${portPropKey}">${portPropName}: ${portPropValue}</span>`)
            }
            itemList.push(`<div class="item-group">${keyNamePrefix} ${portItemList.join(' ')}</div>`)
        }

        return itemList;
    }

    let parseNodeList = function (nodeList) {
        if (!Array.isArray(nodeList)) {
            return
        }

        let itemList = [];
        for (let nodeKey in nodeList) {
            let node = nodeList[nodeKey];
            console.log(nodeKey, node)
            if (!node.hasOwnProperty('node_index')) {
                continue;
            }
            let nodeIndex = node['node_index'];
            if (!node.hasOwnProperty('port_list')) {
                continue;
            }
            let portList = node['port_list'];
            let itemListFromPort = parsePortList(portList, nodeIndex);
            if (!itemListFromPort) {
                continue;
            }

            itemList.push(...itemListFromPort)
        }

        return itemList;
    }

    // parse selected key list
    console.log(typeName, keyList, allItems);
    let itemList = [];
    for (let i in keyList) {
        let k = keyList[i];
        let name = FRAME_KEY_NAME[k] || '';
        if (!name) { continue }

        let v = allItems[k];
        if (v === undefined) {
            continue;
        }

        switch (k) {
            case 'node.p_1_status':
            case 'node.p_2_status': {
                v = `${v}(${portStatusFormat(v)})`;
                break;
            }

            case 'node.p_1_current':
            case 'node.p_2_current': {
                v = sprintf('%.3fA', v / 1000);
                break;
            }

            // 客户反应现有的功率都少乘了10
            // 故替换  v = sprintf('%.1fW', v / 10);
            // 为      v = sprintf('%.1fW', v)
            case 'node.p_1_power':
            case 'node.p_2_power': {
                // v = sprintf('%.1fW', v / 10);
                v = sprintf('%.1fW', v);
                break;
            }

            // 反应现有的最大功率都多乘了10
            // 不知是单位换算缘故还是其他什么原因导致
            // 先转换为为客户想要的数值
            // 故增加最大功率 v = v / 10 + "W"的操作
            case 'node.p_1_config_max_power':
            case 'node.p_2_config_max_power': {
                v = v / 10 + 'W'
            } break;

            case 'node.p_1_finish_time':
            case 'node.p_2_finish_time': {
                v = timeFormat(v)
            } break;

            case 'node.p_1_power_time_consumed_list':
            case 'node.p_2_power_time_consumed_list': {
                if (Array.isArray(v)) {
                    v = v.join(',')
                }
            } break;

            case 'node.p_1_finish_reason':
            case 'node.p_2_finish_reason': {
                switch (v) {
                    case 1: v = '充满自停'; break;
                    case 2: v = '异常停止'; break;
                    case 3: v = '正常停止（充电时间到）'; break;
                }
            } break;

            case 'result': {
                switch (v) {
                    case 0: v = t(/*失败*/'frame.failure'); break;
                    case 1: v = t(/*成功*/'frame.success'); break;
                }
            } break;

            case 'card.charge_type': {
                switch (v) {
                    case 1: v = '按时计费'; break;
                    case 2: v = '按量计费'; break;
                    case 3: v = '按功率计费'; break;
                }
            } break;

            case 'card.power_config': {
                let parts = [];
                if (Array.isArray(v)) {
                    for (let i in v) {
                        parts.push(`档位${parseInt(i) + 1}: 功率${v[i]['power']}单价${v[i]['price']}`)
                    }
                }
                v = parts.join(", ");
                v = `[${v}]`;
            } break;

            case 'gun_status': {
                v = `${v}(${gunStatusFormat(v)})`;
            } break;

            case 'car_charge_event': {
                switch (v) {
                    case 0x1001: v = '插枪事件'; break;
                    case 0x1002: v = '拔枪事件'; break;
                    case 0x2001: v = '过压发生'; break;
                    case 0x2002: v = '过压恢复'; break;
                    case 0x2011: v = '欠压发生'; break;
                    case 0x2012: v = '欠压恢复'; break;
                    case 0x3001: v = '停按钮触发'; break;
                    case 0x3002: v = '停按钮恢复'; break;
                    case 0x3011: v = '继电器过温发生'; break;
                    case 0x3012: v = '继电器过温恢复'; break;
                    case 0x3021: v = '过载过流发生'; break;
                    case 0x3022: v = '过载过流恢复'; break;
                    case 0x3031: v = '计量通讯异常'; break;
                    case 0x3032: v = '计量通讯恢复'; break;
                    case 0x3041: v = '继电器粘连'; break;
                    case 0x3042: v = '继电器粘连恢复'; break;
                }
            } break;
        }

        console.log('final', k, v);
        if (k === 'node_list') {
            let itemListFromNodeList = parseNodeList(v);
            if (itemListFromNodeList) {
                itemList.push(...itemListFromNodeList)
            }
        } else if (k === 'port_list') {
            let nodeIndex = allItems['node_index'] || 0;
            let itemListFromPortList = parsePortList(v, nodeIndex);
            if (itemListFromPortList) {
                itemList.push(...itemListFromPortList)
            }
        } else {
            let content = `<span class="item">${name}: ${v}</span>`;
            itemList.push(content)
        }
    }
    let content = itemList.join(' ');
    return `<span class="item">[${typeName}]</span> ${content}`;
}